import { render, staticRenderFns } from "./createCMgt.vue?vue&type=template&id=cf7c4952&"
import script from "./createCMgt.vue?vue&type=script&lang=js&"
export * from "./createCMgt.vue?vue&type=script&lang=js&"
import style0 from "./createCMgt.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports